module.exports = __webpack_public_path__ + "static/media/illustration-send-link-to-client.308b231e.png";